import { ManagementTeam } from "./ManagementTeam";

export default ManagementTeam;